<script lang="ts" setup>
import NoData from './no-data.vue'
import FilterDropdown from '~/components/mobile/common/filter-dropdown-v2.vue'
import CasinoItem from '~common/casino/casino-item.vue'
import LoadMoreButton from '~/components/desktop/pages/common/load-more-button.vue'
import { ModalCollection } from '~/constants'
import type { DropdownItem } from '~/composables/common/interface'
import type { CasinoItemGame } from '~composables/casino/interface'

type Props = {
  provider: string
  category: string
  providers: DropdownItem[]
  categories: DropdownItem[]
  gamesToShow: CasinoItemGame[]
  limit: number
  totalGames: number
  keywordSearch: string
}

const {
  limit,
  provider,
  category,
  providers,
  categories,
  totalGames,
  gamesToShow,
  keywordSearch
} = defineProps<Props>()

const emit = defineEmits<{
  selectProvider: [selected: string]
  selectCategory: [selected: string]
  playCasinoGame: [game: CasinoItemGame]
  loadMore: []
}>()
</script>

<template>
  <div class="top-casino">
    <div class="filter-layout">
      <FilterDropdown
        label="Nhà cung cấp"
        isLabelFloating
        iconTypeImage
        :valueSelected="provider"
        :modalId="ModalCollection.FILTER_DROPDOWN_MODAL"
        :optionItems="providers"
        @handleItemSelected="item => emit('selectProvider', item.value)"
      />

      <FilterDropdown
        label="Thể loại"
        isLabelFloating
        :valueSelected="category"
        :modalId="ModalCollection.SELECT_CATEGORY_CASINO"
        :optionItems="categories"
        @handleItemSelected="item => emit('selectCategory', item.value)"
      />
    </div>

    <template v-if="gamesToShow.length">
      <div class="list-casino-games">
        <div v-for="(games, index) in gamesToShow" :key="index" class="grid-item">
          <CasinoItem :item="games" :playCasinoGame="(game: CasinoItemGame) => emit('playCasinoGame', game)" />
        </div>
      </div>

      <LoadMoreButton :limit="limit" :total="totalGames" class="load-more" @loadMore="emit('loadMore')" />
    </template>

    <NoData v-else :keywordSearch="keywordSearch" />
  </div>
</template>

<style scoped lang="scss">
@import '~scssAsset/mobile/casino/casino-direct.scss';
</style>
